
export const SearchHelper = () => {

  // ensure the field is set back to empty
  const searchReset = document.getElementById('search-reset')
  const search = document.getElementById("search")
  if (searchReset) {
    searchReset.addEventListener("click", (event) => {
      event.preventDefault()
      search.value = ''
      search.focus()
    })
  }

  // set focus to the search field after toggle is open
  document.getElementById('header-quick-search').addEventListener("toggle", (event) => {
    if (event.newState === "open") {
      document.getElementById("quick-search-input").focus();
    }
  })


}

